// Venue-search VS1.3. Reads the field dictionary (fields.json, a copy of
// functions/taxonomy/) and its words (strings.en.json). The only place the
// site gets field IDs, lists and labels from. How the files work:
// docs/FIELD-DICTIONARY.md.
import dictionary from './fields.json';
import strings from './strings.en.json';

export { dictionary, strings };

const byId = (entity) => new Map(dictionary.entities[entity].fields.map((field) => [field.id, field]));
const venueFields = byId('venue');

export const venueField = (id) => {
  const field = venueFields.get(id);
  if (!field) throw new Error(`Unknown venue field: ${id}`);
  return field;
};

const words = (id) => strings.fields.venue[id] || {};
export const fieldLabel = (id) => words(id).label;
export const fieldDefinition = (id) => words(id).definition;
export const fieldHelp = (id) => words(id).help;
export const maxLength = (id) => venueField(id).rule?.maxLength;

// The options a form offers: every value except retired ones.
// `except` leaves out more values (e.g. "other" where the form has no box for it).
export const listOptions = (list, { except = [] } = {}) => {
  const { values, retired = [] } = dictionary.lists[list];
  return values.filter((id) => !retired.includes(id) && !except.includes(id)).map((id) => ({ id, label: strings.lists[list][id] }));
};

export const valueLabel = (list, id) => strings.lists[list][id];

// Lists stored today as their old labels (until VS2.1): label <-> ID.
export const toLegacy = (list, id) => dictionary.lists[list].legacy?.[id];
export const fromLegacy = (list, label) => {
  const legacy = dictionary.lists[list].legacy || {};
  return Object.keys(legacy).find((id) => legacy[id] === label);
};

export const regionOf = (country = 'US') => dictionary.regions[country] || dictionary.regions.US;
